/** `/forgot-password` — запрос ссылки на сброс пароля (PULSE-269). */
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { AuthLayout } from '@/components/layout/AuthLayout'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { FormField } from '@/components/ui/FormField'
import { useForgotPassword } from '@/hooks/useAuthApi'

interface FormValues { email: string }

export default function ForgotPassword() {
  const { t } = useTranslation(['auth', 'common'])
  const forgot = useForgotPassword()
  const [sent, setSent] = useState(false)

  const { register, handleSubmit, formState: { errors } } = useForm<FormValues>()

  async function onSubmit(values: FormValues) {
    try {
      await forgot.mutateAsync(values.email)
      setSent(true)
    } catch {
      // /auth/forgot всегда 200 — сюда попадём только при сетевой ошибке
      setSent(true)
    }
  }

  return (
    <AuthLayout
      title={t('auth:forgot.title')}
      subtitle={t('auth:forgot.subtitle')}
      footer={
        <Link className="text-fire hover:underline" to="/login">
          {t('auth:forgot.back_login')}
        </Link>
      }
    >
      {sent ? (
        <div className="bg-pulse/10 border border-pulse/30 text-sm text-text rounded px-3 py-3 leading-relaxed">
          {t('auth:forgot.done')}
        </div>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <FormField
            label={t('auth:login.email_label')}
            htmlFor="email" error={errors.email?.message}
          >
            <Input
              id="email"
              type="email"
              autoFocus
              autoComplete="email"
              placeholder={t('auth:login.email_placeholder')}
              invalid={!!errors.email}
              {...register('email', {
                required: t('auth:validation.email_required'),
                pattern: {
                  value: /\S+@\S+\.\S+/,
                  message: t('auth:validation.email_invalid'),
                },
              })}
            />
          </FormField>
          <Button type="submit" className="w-full" loading={forgot.isPending}>
            {t('auth:forgot.submit')}
          </Button>
        </form>
      )}
    </AuthLayout>
  )
}
